<ng-template #modalShowEbed let-modal id="modalShowEbed">
  <div class="modal-header">
    <h4 class="modal-title">{{getTitle()}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-pbi">
    <div id="pbi-content"></div>
  </div>
  <div class="modal-footer" *ngIf="showFooter">
    <span *ngIf="selectObject && currentObject">{{currentTitle}}({{currentType}})
      <span>Selected</span>
    </span>
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Cancel')" i18n="@@genericCancelButtonLabel">Cancel</button>
    <button type="button" class="btn btn-info" (click)="emitGetFilter(modal)" i18n="@@ApplyGenericButtonLabel" *ngIf="showFilter &&!selectObject">Apply</button>
    <button type="button" class="btn btn-info" (click)="emitSelectObject(modal)" i18n="@@SelectGenericButtonLabel" *ngIf="selectObject &&currentObject!=''" >Select</button>
  </div>
</ng-template>
